import { Action } from '../../common/actions/core/action';

export class OpenMasterpassInfoAction implements Action {
  constructor() {}
}



// WEBPACK FOOTER //
// src/app/buy/masterpass-info-dialog/masterpass-info-dialog.action.ts